/*
  abeauty-pdp.js (2026-10-02, corectie 3.10.2026)

  Pagina de produs fara clinica preselectata (Etapa 1) + bara fixa de cumparare pe mobil (Etapa 2).

  Serverul (product-variant-picker.liquid) pune un placeholder „Alege clinica" /
  „Alege zona" in fiecare select cand URL-ul nu are ?variant=, iar buy-buttons.liquid
  lasa id-ul variantei gol si butonul dezactivat. Scriptul de aici:

  1. Asculta `change` in faza de capture pe <product-info>, INAINTEA handlerului
     Dawn din <variant-selects>. Cat timp mai exista un select pe placeholder,
     opreste propagarea: Dawn nu mai cere sectiunea cu doar o parte din optiuni
     (Shopify ar completa singur optiunile lipsa, de ex. prima zona, si ar activa
     butonul cu o varianta pe care clientul n-a ales-o). Cand toate optiunile sunt
     alese, evenimentul trece mai departe si Dawn face ce facea si inainte: pret,
     buton, URL cu ?variant=.
  2. Muta atributul `selected` pe optiunea aleasa (Dawn citeste `option[selected]`,
     nu `select.value`), ca la urmatoarea alegere cererea sa plece cu id-urile bune.
  3. Blocheaza submit-ul formularului de adaugare in cos cat timp selectia e
     incompleta si duce focusul pe primul select ramas pe placeholder.
  4. Anunta bara fixa de pe mobil prin evenimentul `abeauty:selectie`.
  5. Bara fixa (snippets/abeauty-pdp-sticky.liquid, randata din layout): apare cand
     butoanele de cumparare nu sunt in viewport; eticheta urmareste selectia; click =
     deruleaza la selectul ramas pe placeholder sau trimite formularul; pretul se
     actualizeaza din `variantChange` al lui Dawn.

  Se initializeaza pe toate <product-info> existente si pe cele incarcate ulterior
  (quick-add-ul din colectii trimite `product-info:loaded`).
*/
(function () {
  'use strict';

  var LABEL_FALLBACK = 'Alege clinica';
  var LABEL_BUY = 'Cumpără';

  function selectsOf(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('variant-selects select'));
  }

  function incompleteSelect(scope) {
    var sels = selectsOf(scope);
    for (var i = 0; i < sels.length; i++) {
      if (sels[i].value === '') return sels[i];
    }
    return null;
  }

  /* 3.10.2026: id-urile de optiune se citesc din SELECTIE, nu din atributul `selected`.
     Dawn (VariantSelects.updateSelectionMetadata) muta atributul scotandu-l intai de pe
     optiunea veche; in WebKit (Safari si Chrome pe iPhone) acea stergere reseteaza selectul
     pe prima optiune activa, adica Bucuresti Tei, si cererea de sectiune pleca cu clinica
     gresita. De aceea evenimentul de selectie se publica de aici, iar handlerul Dawn nu
     mai primeste `change` (stopPropagation in faza de capture). */
  function selectedOptionValueIds(scope) {
    var ids = [];
    selectsOf(scope).forEach(function (s) {
      var o = s.options[s.selectedIndex];
      if (o && o.value !== '' && o.dataset && o.dataset.optionValueId) ids.push(o.dataset.optionValueId);
    });
    Array.prototype.forEach.call(scope.querySelectorAll('variant-selects fieldset input:checked'), function (i) {
      if (i.dataset && i.dataset.optionValueId) ids.push(i.dataset.optionValueId);
    });
    return ids;
  }

  function publishSelection(scope, event, chosen) {
    if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.optionValueSelectionChange) {
      return false;
    }
    publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
      data: { event: event, target: chosen, selectedOptionValues: selectedOptionValueIds(scope) },
    });
    return true;
  }

  function submitButton(scope) {
    return scope.querySelector('.product-form__submit');
  }

  function labelFor(select, button) {
    if (select && select.dataset && select.dataset.abChooseLabel) return select.dataset.abChooseLabel;
    return (button && button.dataset && button.dataset.abLabelClinic) || LABEL_FALLBACK;
  }

  function lockButton(scope, label) {
    var btn = submitButton(scope);
    if (!btn) return;
    btn.setAttribute('disabled', 'disabled');
    var span = btn.querySelector('span');
    if (span && label) span.textContent = label;
  }

  function emit(scope, complete, label) {
    try {
      document.dispatchEvent(
        new CustomEvent('abeauty:selectie', {
          detail: { complete: complete, label: label || null, scope: scope },
        })
      );
    } catch (e) {
      /* browsere vechi fara CustomEvent: bara fixa ramane pe starea initiala */
    }
  }

  function onChange(scope, event) {
    var target = event.target;
    if (!target || target.tagName !== 'SELECT') return;
    if (!target.closest || !target.closest('variant-selects')) return;
    var chosen = target.options[target.selectedIndex];
    var missing = incompleteSelect(scope);
    if (!missing) {
      emit(scope, true, null);
      /* selectia e completa: cererea de sectiune pleaca de aici, cu id-urile din selectie;
         daca pubsub-ul Dawn lipseste, evenimentul trece mai departe ca inainte */
      if (chosen && publishSelection(scope, event, chosen)) event.stopPropagation();
      return;
    }
    event.stopPropagation();
    var label = labelFor(missing, submitButton(scope));
    lockButton(scope, label);
    emit(scope, false, label);
  }

  function onSubmit(scope, event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    var missing = incompleteSelect(scope);
    if (!missing) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    var label = labelFor(missing, submitButton(scope));
    lockButton(scope, label);
    var productForm = scope.querySelector('product-form');
    if (productForm && typeof productForm.handleErrorMessage === 'function') {
      productForm.handleErrorMessage(label + ' înainte de a adăuga în coș.');
    }
    missing.focus();
    if (missing.scrollIntoView) missing.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  function init(productInfo) {
    if (!productInfo || !productInfo.dataset || productInfo.dataset.abPdp === '1') return;
    productInfo.dataset.abPdp = '1';
    productInfo.addEventListener('change', function (e) { onChange(productInfo, e); }, true);
    productInfo.addEventListener('submit', function (e) { onSubmit(productInfo, e); }, true);
    var missing = incompleteSelect(productInfo);
    var label = missing ? labelFor(missing, submitButton(productInfo)) : null;
    if (missing) lockButton(productInfo, label);
    emit(productInfo, !missing, label);
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('product-info'), init);
  }

  /* ------------------------------------------------------------ bara fixa (Etapa 2) */

  function formatLei(cents) {
    return Math.round(cents / 100) + ' lei';
  }

  /* 2026-10-18: iconița Consentmo (redeschide setările de cookie, stânga jos) stă în shadow DOM-ul
     lui <csm-cookie-consent> și acoperă prețul din bara fixă pe mobil. N-o ascundem (retragerea
     acordului trebuie să rămână la îndemână), doar o ridicăm cât timp bara e vizibilă. Clasele ei
     sunt generate, deci o găsim după poziție: element fix, mic, lângă marginea de jos. */
  function mutaIconitaCookie(urca) {
    var host = document.querySelector('csm-cookie-consent');
    var sr = host && host.shadowRoot;
    if (!sr || !window.matchMedia('(max-width: 749px)').matches) return;
    Array.prototype.forEach.call(sr.querySelectorAll('div, button'), function (el) {
      if (el.dataset.abUrcat !== '1') {
        var cs = getComputedStyle(el);
        if (cs.position !== 'fixed') return;
        var r = el.getBoundingClientRect();
        if (r.width === 0 || r.width > 90 || r.height > 90 || parseFloat(cs.bottom) > 40) return;
        el.dataset.abUrcat = '1';
        /* Consentmo își pune poziția inline: o păstrăm, ca s-o refacem exact. */
        el.dataset.abBottom = el.style.getPropertyValue('bottom');
        el.dataset.abBottomPrio = el.style.getPropertyPriority('bottom');
      }
      if (urca) el.style.setProperty('bottom', 'calc(80px + env(safe-area-inset-bottom))', 'important');
      else if (el.dataset.abBottom) el.style.setProperty('bottom', el.dataset.abBottom, el.dataset.abBottomPrio);
      else el.style.removeProperty('bottom');
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-ab-sticky]');
    if (!bar) return;
    var main = document.querySelector('product-info[id^="MainProduct-"]') || document.querySelector('product-info');
    if (!main) return;
    var btn = bar.querySelector('[data-ab-sticky-btn]');
    var priceBox = bar.querySelector('[data-ab-sticky-price]');
    var buttons = main.querySelector('.product-form__buttons');

    function setHidden(hidden) {
      bar.setAttribute('data-hidden', hidden ? 'true' : 'false');
      bar.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      /* 2026-10-19: bula WhatsApp urcă deasupra barei cât timp bara e vizibilă
         (snippets/abeauty-whatsapp.liquid), altfel acoperă prețul din bară. */
      document.documentElement.classList.toggle('ab-sticky-vizibil', !hidden);
      mutaIconitaCookie(!hidden);
    }

    /* Iconița apare abia după ce clientul alege în banner, deci reaplicăm starea la orice
       schimbare din shadow DOM-ul Consentmo (îl așteptăm până la 20 de secunde). */
    var incercari = 0;
    (function asteaptaConsentmo() {
      var host = document.querySelector('csm-cookie-consent');
      if (host && host.shadowRoot && window.MutationObserver) {
        new MutationObserver(function () {
          mutaIconitaCookie(bar.getAttribute('data-hidden') === 'false');
        }).observe(host.shadowRoot, { childList: true, subtree: true });
        return;
      }
      if (++incercari < 20) setTimeout(asteaptaConsentmo, 1000);
    })();

    function refreshLabel() {
      var missing = incompleteSelect(main);
      if (btn) btn.textContent = missing ? labelFor(missing, submitButton(main)) : LABEL_BUY;
    }

    if (buttons && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          setHidden(e.isIntersecting);
        });
      }, { threshold: 0 });
      io.observe(buttons);
    } else {
      setHidden(false);
    }

    document.addEventListener('abeauty:selectie', function (e) {
      if (!e.detail || e.detail.scope !== main) return;
      if (btn) btn.textContent = e.detail.complete ? LABEL_BUY : (e.detail.label || LABEL_FALLBACK);
    });

    if (btn) {
      btn.addEventListener('click', function () {
        var missing = incompleteSelect(main);
        if (missing) {
          missing.focus();
          if (missing.scrollIntoView) missing.scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }
        var form = main.querySelector('form[data-type="add-to-cart-form"]');
        var submit = submitButton(main);
        if (!form || !submit || submit.hasAttribute('disabled')) {
          if (submit && submit.scrollIntoView) submit.scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }
        if (typeof form.requestSubmit === 'function') form.requestSubmit(submit);
        else submit.click();
      });
    }

    /* pretul urmareste varianta aleasa (Dawn publica variantChange dupa ce actualizeaza pagina) */
    /* `PUB_SUB_EVENTS` e declarat cu const in pubsub.js, deci NU e proprietate pe window; se citeste direct. */
    var evenimente = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;
    if (priceBox && typeof subscribe === 'function' && evenimente && evenimente.variantChange) {
      subscribe(evenimente.variantChange, function (payload) {
        var v = payload && payload.data && payload.data.variant;
        if (!v || typeof v.price !== 'number') return;
        while (priceBox.firstChild) priceBox.removeChild(priceBox.firstChild);
        if (typeof v.compare_at_price === 'number' && v.compare_at_price > v.price) {
          var s = document.createElement('s');
          var eticheta = document.createElement('span');
          eticheta.className = 'visually-hidden';
          eticheta.textContent = 'preț vechi ';
          s.appendChild(eticheta);
          s.appendChild(document.createTextNode(formatLei(v.compare_at_price)));
          priceBox.appendChild(s);
          priceBox.appendChild(document.createTextNode('\u00a0'));
        }
        var strong = document.createElement('strong');
        strong.textContent = formatLei(v.price);
        priceBox.appendChild(strong);
      });
    }

    refreshLabel();
  }

  document.addEventListener('product-info:loaded', function (e) {
    if (e.target && e.target.tagName === 'PRODUCT-INFO') init(e.target);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); initSticky(); });
  } else {
    initAll();
    initSticky();
  }
})();
